import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const YM_ID = Number(process.env.NEXT_PUBLIC_YM_COUNTER_ID);

const useYandexRuntime = (enabled: boolean) => {
  const pathname = usePathname();

  // page tracking
  useEffect(() => {
    if (!enabled || !window.ym) return;
    window.ym(YM_ID, 'hit', pathname);
  }, [pathname, enabled]);
};

export default useYandexRuntime;
